const Footer = () => {
  return (
    <footer className="border-t border-border/40 mt-10">
      <div className="container mx-auto px-6 py-4 text-center">
        <p className="text-sm text-muted-foreground">
          Made with 🫶 by Aadarsh K A S
        </p>
        <p className="text-sm text-muted-foreground">
          © 2024 Aadarsh K A S All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
